

import React, {Suspense, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Helmet from "react-helmet";
import axios from "axios";
import {Link} from "react-router-dom";
import CardBlogPost from "../components/card/card_blog_post";

function ScienceWorkPage(props) {

    const { t, i18n } = useTranslation()

    const dataYears = [2024, 2023, 2022, 2021, 2020, 2019]

    const [filterYear, setFilterYear] = useState(0);

    const handleFilter = (value) => {
        setFilterYear(value)
    }

    const [scienceWork, setScienceWork] = useState([]);

    const [load, setLoad] = useState(true);

    useEffect(()=> {

        axios.get(
            '/assets/data/science-work.json'
        ).then(function (response) {
            const getScienceWork = response.data;
            setScienceWork(getScienceWork);
            console.log(getScienceWork);
            setLoad(false);
        }).catch(err => {
            // In case it errors.
            console.log(err);
        });

    }, []);

    return ( load ? 'Loading...' : <div className={'container h-auto'}>

        <Helmet>
            <title>{t('nav.science-work')} - {t('me.name')}</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container text-dark text-start pt-5 pb-4">

            <h1 className={'opacity-50'} style={{fontSize: '8vw'}}>🎓{t('nav.science-work')}</h1>

            <div className="d-flex flex-wrap">
                <div className="col-md-">
                    <div className={'pt-2 p-1'}>
                        <button className="btn bg-secondary-subtle p-2 rounded" onClick={() => handleFilter(0)}>
                            <small className={'text-uppercase'}> {t('subTitle.all')} </small>
                        </button>
                    </div>
                </div>
                {
                    dataYears.map((year, i) => <div className="col-md-">
                        <div className={'pt-2 p-1'}>
                            <button className="btn bg-secondary-subtle p-2 rounded" onClick={() => handleFilter(year)}>
                                <small> {year}</small>
                            </button>
                        </div>
                    </div>)
                }


            </div>

            <br/>

            {
                scienceWork.length > 0 &&
                scienceWork.filter((a) => filterYear != 0 ? a.year == filterYear : true).map((item, i) =>

                    <CardBlogPost key={i} data={item} label={'title.read'} />

                //     <div id={i} className="d-flex flex-wrap justify-content-between mt-5 align-items-end">
                //     <div className="">
                //         <small className={'text-secondary'}>{item.year} #{item.type}</small>
                //         <h4>
                //             {
                //                 i18n.language === 'ua' ? item.title : item.title_en
                //             }
                //         </h4>
                //     </div>
                //     <div className="col-md-">
                //         <Link to={item.link} target={'_blank'} className={'text-decoration-none text-secondary d-flex align-items-center'}>
                //             <small className={'lead'}>
                //                {t('subTitle.download')}
                //
                //                 <svg
                //                     xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                //                     className="bi bi-box-arrow-in-up-right m-1" viewBox="0 0 16 16">
                //                     <path fill-rule="evenodd"
                //                           d="M6.364 13.5a.5.5 0 0 0 .5.5H13.5a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 13.5 1h-10A1.5 1.5 0 0 0 2 2.5v6.636a.5.5 0 1 0 1 0V2.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H6.864a.5.5 0 0 0-.5.5"/>
                //                     <path fill-rule="evenodd"
                //                           d="M11 5.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793l-8.147 8.146a.5.5 0 0 0 .708.708L10 6.707V10.5a.5.5 0 0 0 1 0z"/>
                //                 </svg>
                //             </small>
                //         </Link>
                //     </div>
                // </div>
                )
            }



        </div>
    </div>);
}

export default ScienceWorkPage;
